import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { getCurrentLanguage } from '~/i18n';
import { resolveHelp } from '~config/helpCenter';
import styles from './HelpLink.module.css';

const HelpLink: React.FC = () => {
  const { pathname } = useLocation();
  const { href, label } = resolveHelp(pathname, getCurrentLanguage());
  return (
    <a className={styles.HelpLink} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
      <i className={`icon-question ${styles.Mark}`} aria-hidden />
      <span className={styles.Tooltip} role="tooltip">
        {label}
      </span>
    </a>
  );
};

export default HelpLink;
